import * as React from "react"
import { Link } from "gatsby"
import SideDrawer from "./newSidedrawer"
import { useState, useEffect } from "react"
import { RenderRichContent } from "../RenderRichContent/RenderRichContent"
import * as styles from "./newHeader.module.scss"
import ButtonExternal from "../buttons/buttonExternal"
import ButtonInternal from "../buttons/buttonInternal"
import { useLocation } from "@reach/router"
import SearchIcon from "../../images/search-ED.svg"

const NewHeader = ({ data, urlContent }) => {
  let sideDrawer
  let backDrop
  const location = useLocation()

  const [SideDrawerOpen, setSideDrawerOpen] = useState(false)
  function handleClick() {
    setSideDrawerOpen(false)
  }

  function openSideDrawer() {
    setSideDrawerOpen(true)
  }

  if (SideDrawerOpen) {
    backDrop = (
      <div
        className={
          "w-full fixed top-0 left-0 bg-black bg-opacity-50 h-full z-30 xl:hidden"
        }
        role="backdrop"
        onClick={handleClick}
      />
    )
    sideDrawer = (
      <SideDrawer
        data={data.node}
        onClick={handleClick}
        urlContent={urlContent}
        showSidebar={SideDrawerOpen}
      />
    )
  }

  const [scroll, setScroll] = useState(false)

  useEffect(() => {
    window.addEventListener("scroll", () => {
      setScroll(window.scrollY > 135)
    })
  }, [])

  let firstURLElement = ""
  let secondURLElement = ""
  let thirdURLElement = ""

  const urlMaker = () => {
    if (data.node.node_locale === "de") {
      firstURLElement = urlContent[0] || ""
      secondURLElement = urlContent[1] || ""
      thirdURLElement = urlContent[3] || ""
    } else if (data.node.node_locale === "nl") {
      firstURLElement = urlContent[1] || ""
      secondURLElement = urlContent[2] || ""
      thirdURLElement = urlContent[3] || ""
    } else if (data.node.node_locale === "en") {
      firstURLElement = urlContent[0] || ""
      secondURLElement = urlContent[2] || ""
      thirdURLElement = urlContent[3] || ""
    } else if (data.node.node_locale === "en-US") {
      firstURLElement = urlContent[1] || ""
      secondURLElement = urlContent[0] || ""
      thirdURLElement = urlContent[2] || ""
    }
  }

  urlMaker()

  return (
    <header
      className={`w-full text-sm min-h-20 h-20 bg-white shadow-xl font-medium ${
        scroll ? "lg:h-24" : "lg:h-28"
      } z-40 fixed transition-all duration-700`}
    >
      <div
        className={`max-w-[1224px] bg-white items-center mx-auto mb-[4.5px] mt-[4.5px] hidden relative fixed ${
          scroll ? "h-0" : "h-5"
        } lg:block xl:block transition-all duration-700`}
      >
        <ul
          className={`flex justify-end m-0 leading-none uppercase text-[#6b7280] gap-[27px] ${
            scroll ? "h-0 text-transparent" : "h-full"
          }`}
        >
          <li className="text-xs lg:text-[0.7rem] m-0 gap-[8px] flex items-center">
            <a
              href={data.node.registerLink}
              target="_blank"
              rel="noreferrer"
              className={`${scroll ? 'hidden' : 'hover:text-edc-light-blue'} px-2`}
            >
              {data.node.registerLinkText}
            </a>
            |
            <a
              href={data.node.supportLink}
              target="_blank"
              rel="noreferrer"
              className={`${scroll ? 'hidden' : 'hover:text-edc-light-blue'} px-2`}
            >
              {data.node.supportLinkText}
            </a>
          </li>
          <li className={`text-xs lg:text-[0.7rem] m-0 flex items-center group z-50 ${
            scroll ? "h-0 text-transparent" : "text-edc-light-blue h-full"
          }`}>
            <p className={`m-0 text-xs z-50 group ${
              scroll ? "text-transparent" : "text-[#6b7280]"
            }`}>
              {data.node.currentLanguage}
            </p>
            <span className={`${scroll ? " hidden" : "rounded-sm ml-2 group bg-none transition-all duration-75"}`}>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 my-0.5 z-50" viewBox="0 0 20 20" fill="#6b7280">
                <path
                  fillRule="evenodd"
                  d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </span>
            <ul className={`bg-white shadow rounded-sm top-5 m-0 absolute z-20 hidden group ${
              scroll ? "group-hover:none" : "group-hover:block"
            }`}>
              {[0, 1, 2].map(i => (
                <li key={i} className="text-edc-light-blue hover:bg-gray-300 p-0 m-0">
                  <a href={`${data.node.languageSwitchUrls[i]}/${[firstURLElement, secondURLElement, thirdURLElement][i]}`} className="px-4 py-3 inline-block">
                    {data.node.languageSwitchLanguageCode[i]}
                  </a>
                </li>
              ))}
            </ul>
          </li>
        </ul>
      </div>

      {!scroll && (
  <div className="xl:w-full xl:border-b xl:border-black lg:w-full lg:border-b lg:border-black xl:opacity-10 lg:opacity-10"></div>
)}


      <nav className="w-full bg-white h-20 lg:h-16 xl:h-20 flex justify-between lg:justify-between items-center mx-auto px-3 lg:px-0 lg:py-0 py-2 transition-all max-w-[1224px] ease-in-out duration-300">
        <div className="flex items-center justify-between md:gap-0 lg:gap-16 xl:gap-24 ">
          <Link to="/" className={`flex-shrink-0 z-0 transition-all duration-700 ${
            scroll ? " mt-0" : "mt-0"
          }`}>
            <img
              src={data.node.icon.file.url}
              className={`lg:w-[70px] lg:h-[70px] xl:w-[75px] xl:h-[75px] h-[60px] w-[60px] my-auto lg:absolute md:pb-0 ${
                scroll ? "lg:top-3" : "lg:top-[2.3rem]"
              }`}
              alt={data.node.icon.description || "ed controls logo"}
            />
          </Link>
          <div className="flex items-center lg:w-[90%]">
            {data.node.headerLinks.map((headerlink, index) => {
              if (headerlink.menuItemSubs) {
                return (
                  <ul
                    className={"m-0 py-8 mr-6 " + styles.dropdown}
                    key={index}
                  >
                    <li
                      className={
                        "relative m-0 mr-0 font-normal lg:text-[0.8rem] xl:text-[0.9rem] flex flex-row flex-start items-center"
                      }
                    >
                      <RenderRichContent
                        content={headerlink.menuItemNameLink}
                        role={"headerlink"}
                        key={index}
                        classNames={"m-0 shrink-0"}
                      />
                      <span
                        className={`rounded-sm ml-1 md:ml-0 transition-all duration-75 mr-8 md:mr-2 hidden lg:block xl:block`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="h-4 w-5 my-0.5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fillRule="evenodd"
                            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </span>
                    </li>
                    <li className={"m-0 py-0"}>
                      <ul
                        className={`absolute ${
                          index === 1 ? "mt-[-5px]" : "mt-8"
                        } m-0 bg-white shadow-xl  ${styles.dropdownMenu}`}
                      >
                        {index === 1
                          ? headerlink.menuItemSubs.map(
                              (subMenuItem, index) => {
                                return (
                                  <li
                                    className="flex items-center p-4 hover:bg-gray-300 relative max-h-[58px] "
                                    key={index}
                                  >
                                    <RenderRichContent
                                      content={subMenuItem.menuItemNameLink}
                                      role={"dropdownlinkWithIcon"}
                                    />
                                  </li>
                                )
                              }
                            )
                          : index === 0
                            ? <li className={`flex flex-start bg-white px-[40px] pb-[10px]`}>
                                {headerlink.menuItemSubs.map((subMenuItem, index) => {
                                  if (subMenuItem.subCategoryMenuItems) {
                                    return (
                                      <div key={index}>
                                        {/* Header */}
                                        <div className="py-3 px-2 ">
                                          <RenderRichContent
                                            content={subMenuItem.subCategoryMenuItemsHeading}
                                          />
                                        </div>
                            
                                        {/* Subcategories List */}
                                        <ul className="list-none p-0 m-0 mt-[10px]">
                                          {subMenuItem.subCategoryMenuItems.map((subCategory, subIndex) => (
                                            <li 
                                              key={`subcategory-${subIndex}`}
                                              className={`flex items-center py-3 px-2 relative hover:bg-gray-300`}
                                            >
                                              <RenderRichContent content={subCategory.menuItemNameLink} />
                                            </li>
                                          ))}
                                        </ul>
                                      </div>
                                    );
                                  }
                                  return null;
                                })}
                              </li>
                            : headerlink.menuItemSubs.map(
                                (subMenuItem, index) => {
                                  return (
                                    <li key={index}>
                                      <RenderRichContent
                                        content={subMenuItem.menuItemNameLink}
                                        role={"dropdownlink"}
                                      />
                                    </li>
                                  )
                                }
                              )
                        }
                      </ul>
                    </li>
                  </ul>
                )
              } else {
                return (
                  <div className="list-none m-0" key={index}>
                    <RenderRichContent
                      content={headerlink.menuItemNameLink}
                      role={"headerlink"}
                      classNames={
                        "mr-8 shrink-0 font-normal lg:text-[0.8rem] xl:text-[0.9rem]"
                      }
                    />
                  </div>
                )
              }
            })}
          </div>
        </div>

        <div className="hidden lg:flex items-center gap-[50px] pl-5 pr-1 min-w-[120px]">
          <Link
            to={`/${data.node.searchLink.slug}`}
            className="items-center justify-center w-6 h-5"
          >
            <img
              src={SearchIcon}
              alt="Search"
              className="w-5 h-5 flex-shrink-0"
            />
          </Link>
          <a
            href={data.node.loginLink}
            target="_blank"
            rel="noreferrer"
            className="text-sm text-gray-700 whitespace-nowrap font-bold hover:text-[#006ef5]"
          >
            {data.node.loginLinkText}
          </a>
        </div>

        <div className={"flex justify-end " + styles.wrapperButtons}>
          {data.node.menuButtons.map((button, index) =>
            button.internalPageReference ? (
              <ButtonInternal
                data={button}
                key={index}
                display={"hidden lg:block xl:block text-center p-2 font-semibold"}
              />
            ) : (
              <ButtonExternal
                data={button}
                key={index}
                display={"hidden xl:block text-center font-semibold"}
              />
            )
          )}
        </div>

        <div
          className="space-y-1.5 cursor-pointer block xl:hidden lg:hidden ease-in-out duration-300"
          onClick={openSideDrawer}
          role="button"
          tabIndex={0}
          onKeyDown={openSideDrawer}
        >
          <div className="w-6 h-0.5 bg-black"></div>
          <div className="w-5 h-0.5 bg-black"></div>
          <div className="w-6 h-0.5 bg-black"></div>
        </div>
      </nav>
      {sideDrawer}
      {backDrop}
    </header>
  )
}

export default NewHeader